import { crud } from '@think-internet/zeus-frontend-package'
import { Survey, SurveyContext, SurveyType } from '../../../../../../types/Survey/Survey'
import props from '../../../../../../redux/props'
import { Analysis } from '../../../../../../types/Survey/Analysis/Analysis'
import getFactorValues from '../../../../../hooks/useAnalysisCalculation/getFactorValues'
import { BueroType } from '../../../../../../types/Survey/Analysis/Calculation'
import { calculateAnwesenheitPercentage, calculateDesksharingPercentage } from '../../../../../hooks/useAnalysisCalculation/calculateResults'
import { ConceptUnitList, ConceptValues, OptimizationMode } from '../../../../../../types/Survey/Analysis/Concept'
import { PrebuildType } from '../../../../../../types/Survey/Element'

type Run = (bueroType: BueroType) => Promise<ConceptUnitList | false>

type UseGetValuesByUnit = (context: SurveyContext) => Run

const useGetValuesByUnit: UseGetValuesByUnit = (context): Run => {
  const analysisFeature = crud.use(props.SURVEY_ANALYSIS)
  const surveyFeature = crud.use(props.SURVEY)

  const getTeamSurvey = async (context: SurveyContext): Promise<Survey | false> => {
    const query = {
      surveyType: SurveyType.TEAM,
      surveyContextUUID: context.uuid,
    }
    const survey = await surveyFeature.get(query)
    if (!survey) return false

    return survey
  }

  const run: Run = async (bueroType: BueroType) => {
    const teamSurvey = await getTeamSurvey(context)
    if (!teamSurvey) return false

    const analysisList: ConceptUnitList = {}

    for (const unit of context.organizationUnitList) {
      const query = {
        surveyUUID: teamSurvey.uuid,
        organizationUnitUUID: unit.uuid,
        userIdentifier: { $exists: false },
      }

      const analysis: Analysis = await analysisFeature.get(query)

      if (analysis) {
        const factorValues = getFactorValues(teamSurvey, analysis)

        const values: ConceptValues = {
          unitUUID: unit.uuid,
          name: unit.name,
          originUnitUUID: unit.uuid,
          splitOption: null,
          productionDistance: unit.productionDistance,
          originalMitarbeiter: unit.employeeAmount,
          bueroType,
          anwesenheitPercentage: null,
          mitarbeiter: unit.employeeAmount,
          factor: factorValues,
          desksharingPercentage: null,
          [PrebuildType.EINZELBUEROS]: undefined,
          [PrebuildType.STAUFLAECHE]: undefined,
          [PrebuildType.SONDERBEDARFE]: undefined,
          [PrebuildType.WORKSTATIONS]: undefined,
          drucker: undefined,
          locker: undefined,
          workcafe: undefined,
          garderobe: undefined,
          optimizationMode: OptimizationMode.STANDARD,
        }

        values.anwesenheitPercentage = calculateAnwesenheitPercentage(teamSurvey, analysis, bueroType, values)
        values.desksharingPercentage = calculateDesksharingPercentage(teamSurvey, analysis, bueroType, values)

        analysisList[unit.uuid] = values
      }
    }

    return analysisList
  }

  return run
}

export default useGetValuesByUnit
